import * as React from 'react';

import './style.scss';

interface Props {
  children: React.ReactNode;
}

const Product = (props: Props) => {
  return (
    <div className='product-container d-flex justify-center align-center' >
      {props.children}
    </div>
  );
};

export default React.memo(Product);
